// Root component — router setup + auth provider.
// Cloudflare Access guards the page (no React-side login flow needed);
// AuthProvider just fetches /api/me to know who logged in + their role.
//
// Route components are code-split via React.lazy so the initial bundle only
// carries the shell + the first route the user lands on (was a single ~655KB
// chunk; lazy-loading splits each page into its own chunk fetched on demand).

import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth';
import Layout from './Layout';
import NotFound from './routes/NotFound';

const Home = lazy(() => import('./routes/Home'));
const ProductDetail = lazy(() => import('./routes/ProductDetail'));
const Mappings = lazy(() => import('./routes/Mappings'));
const Logs = lazy(() => import('./routes/Logs'));
const Alerts = lazy(() => import('./routes/Alerts'));
const Mabang = lazy(() => import('./routes/Mabang'));
const Users = lazy(() => import('./routes/Users'));
const NewProducts = lazy(() => import('./routes/NewProducts'));
const Jobs = lazy(() => import('./routes/Jobs'));
const JobDetail = lazy(() => import('./routes/JobDetail'));

function RouteFallback() {
  return <div className="p-6 text-sm text-gray-400">Loading…</div>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="product/:master_sku" element={<ProductDetail />} />
              <Route path="alerts" element={<Alerts />} />
              <Route path="mabang" element={<Mabang />} />
              <Route path="mappings" element={<Mappings />} />
              <Route path="logs" element={<Logs />} />
              <Route path="users" element={<Users />} />
              {/* Stage 2 W3 — new product ingest */}
              <Route path="new-products" element={<NewProducts />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="jobs/:id" element={<JobDetail />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}
